"use strict";

exports.__esModule = true;
exports.applyTrailingSlashOption = void 0;
const endsWithSuffixes = (suffixes, input) => {
  for (const suffix of suffixes) {
    if (input.endsWith(suffix)) return true;
  }
  return false;
};
const suffixes = [".html", ".json", ".js", ".map", ".txt", ".xml", ".pdf"];
const applyTrailingSlashOption = function (input) {
  let option = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "always";
  if (input === "/") return input;
  const hasTrailingSlash = input.endsWith("/");
  if (endsWithSuffixes(suffixes, input)) {
    return input;
  }
  if (option === "always") {
    return hasTrailingSlash ? input : "".concat(input, "/");
  }
  if (option === "never") {
    return hasTrailingSlash ? input.slice(0, -1) : input;
  }
  return input;
};
exports.applyTrailingSlashOption = applyTrailingSlashOption;